import { apiFetch } from './client';

export async function listTags(): Promise<{ tags: string[] }> {
  return apiFetch('/api/tags');
}
